export const ru = {
  nav: {
    charts: "Натальные карты",
    natalChart: "Натальная карта",
    horoscope: "Гороскопы",
    mysteries: "Тайны",
    oracle: "Консультация",
    auth: "Войти",
    compatibility: "Совместимость",
    calendar: "Когда лучше?",
    profile: "Дашборд",
    back: "Назад"
  },
  auth: {
    title: "Небесный Вход",
    subtitle: "Продолжите свое космическое путешествие или начните новый путь.",
    login: "Войти",
    register: "Создать аккаунт",
    email: "Электронная почта",
    password: "Пароль",
    vk: "Продолжить через VK",
    yandex: "Продолжить через Яндекс",
    google: "Продолжить через Google",
    terms: "Я согласен с условиями Космического сервиса",
    noAccount: "Впервые здесь?",
    hasAccount: "Уже есть аккаунт?",
    forgot: "Забыли пароль?",
    success: {
      signedIn: "Вход выполнен",
      signedUp: "Регистрация успешна",
      signedOut: "Выход выполнен",
      providerLinked: "Аккаунт связан",
      providerUnlinked: "Аккаунт отвязан",
    },
    welcome: "Добро пожаловать!",
    welcomeBack: "С возвращением!",
    linkAccount: "связан с вашим аккаунтом",
    passwordResetEmailSent: "Письмо отправлено",
    passwordResetEmailDescription: "Проверьте почту для сброса пароля",
    resetPassword: "Сброс пароля",
    resetPasswordDescription: "Введите новый пароль для вашего аккаунта",
    newPassword: "Новый пароль",
    confirmPassword: "Подтвердите пароль",
    verifyingCode: "Проверяем ссылку для сброса пароля",
    verifying: "Проверяем",
    passwordResetSuccess: "Пароль успешно изменен",
    passwordResetError: "Ошибка сброса пароля",
    passwordResetSuccessDescription: "Пароль обновлен. Сейчас вы будете перенаправлены на главную страницу.",
    passwordResetErrorDescription: "Ссылка недействительна или истекла. Запросите новую ссылку для сброса.",
    goToHome: "На главную",
    passwordSetupEmailSent: "Письмо отправлено",
    passwordSetupEmailDescription: "Проверьте почту для настройки пароля",
    signOut: "Выйти",
    errors: {
      unknownError: "Произошла ошибка",
      userNotFound: "Пользователь не найден",
      wrongPassword: "Неверный пароль",
      emailInUse: "Email уже используется",
      weakPassword: "Слишком слабый пароль",
      invalidEmail: "Неверный email",
      tooManyRequests: "Слишком много запросов",
      networkError: "Ошибка сети",
      popupClosed: "Окно авторизации закрыто",
      providerAlreadyLinked: "Провайдер уже связан",
      credentialInUse: "Учетные данные уже используются",
      redirectUriMismatch: "Ошибка конфигурации OAuth",
      accountExistsUseSocial: "Аккаунт существует. Используйте социальные сети для входа",
      passwordMismatch: "Пароли не совпадают",
    },
  },
  hero: {
    badge: "Начертано на звездах с 2025 года",
    title1: "Раскройте свой",
    titleAccent: "Небесный",
    title2: "Чертеж.",
    description: "Откройте древнюю мудрость космоса. Наши продвинутые алгоритмы объединяют сакральную геометрию с планетарными выравниваниями, чтобы раскрыть истинное предназначение вашей души.",
    ctaPrimary: "Создать карту",
    ctaSecondary: "Узнать путь",
    moonPhase: "Текущая фаза: Убывающая Луна"
  },
  features: {
    header: "Космические инструменты",
    subheader: "Инструменты, созданные для преодоления разрыва между земным и божественным.",
    items: [
      { title: "Натальное картирование", desc: "Точный снимок небес в момент вашего рождения." },
      { title: "Синастрия", desc: "Глубокий анализ совместимости через призму композитных карт." },
      { title: "Когда лучше?", desc: "Опиши ситуацию и найди лучшие даты для важных дел." },
      { title: "Транзиты 2026", desc: "Персональный разбор по транзитам 2026 года с прогнозом и рекомендациями.", premium: true },
      { title: "Лунный календарь", desc: "Узнайте лучшие дни для стрижки по лунному календарю." },
      { title: "Планирование беременности", desc: "Расчёт благоприятных дат для зачатия с астрологическим анализом.", premium: true }
    ]
  },
  calendar: {
    title: "Когда лучше?",
    subtitle: "Опиши ситуацию и найди лучшие даты для важных дел.",
    inputPlaceholder: "Опиши ситуацию: попросить повышение, запустить проект, записаться на собеседование...",
    button: "Узнать время",
    score: "Оценка силы",
    description: "Космический совет",
    bestDays: "Лучшие дни",
    start_date: "Дата начала",
    end_date: "Дата окончания",
    optional: "опционально",
    details: "Детали дня",
    loading: {
      analyzing: "Анализируем цель...",
      sending: "Отправляем запрос...",
      processing: "Обрабатываем результаты...",
      done: "Готово!"
    },
    noData: "Нет космических данных для этой даты.",
    avoid: "Избегать",
    avoidDesc: "Периоды, которых следует избегать",
    levelA: "Уровень A (лучшее)",
    levelB: "Уровень B",
    levelC: "Уровень C",
    levelD: "Уровень D",
    insights: "Ключевые инсайты",
    next30Days: "Следующие 30 дней",
    haircut: {
      title: "Лунный календарь стрижек",
      location: "Местоположение",
      dateSelector: "Выбрать дату",
      autoLocation: "Авто",
      freeBadge: "Бесплатно",
      growth: "Рост",
      thickness: "Толщина",
      health: "Здоровье",
      auspicious: "Благоприятно",
      neutral: "Нейтрально",
      inauspicious: "Неблагоприятно"
    }
  },
  astroCareer: {
    title: "Астро‑профориентолог",
    subtitle: "Профориентация по натальной карте: сильные стороны, карьерные направления и точные шаги.",
    sideNote: "Карта талантов",
    formTitle: "Исходные данные",
    personLabel: "Чья карта",
    personPlaceholder: "Выберите человека",
    traitsLabel: "Фокус‑качества",
    traitsHint: "Опционально: влияет на акценты и примеры. Можно оставить пустым.",
    formHint: "Основано на натальной карте: важны точное время и место рождения.",
    loadingMessage: "Собираем профориентацию по натальной карте...",
    generateButton: "Собрать профориентацию",
    generating: "Собираем...",
    signalTitle: "Карьерный сигнал",
    confidence: "Уверенность",
    readableTitle: "Текст для вставки",
    readableHint: "Готовый человеко‑читабельный блок для интерфейса.",
    readablePlaceholder: "Здесь появится готовый текст для вставки в интерфейс.",
    cardTitle: "Короткая карточка",
    cardPlaceholder: "Сначала сгенерируйте анализ, чтобы увидеть карточку.",
    cardWhyPlaceholder: "Тут появятся 3 ключевых фактора.",
    scoreLabel: "Балл",
    professions: "Профессии",
    actionSteps: "Шаги развития",
    scoreFactors: "Факторы начисления",
    topPlaceholder: "Запустите анализ, чтобы увидеть топ‑направления.",
    explainabilityPlaceholder: "Explainability появится после генерации.",
    notesPlaceholder: "Нет дополнительных заметок от модели.",
    widgetTitle: "Карьера",
    lockBadge: "Скоро",
    lockNote: "Новая фича ко Дню студента",
    tabs: {
      top: "Топ‑3",
      explainability: "Explainability",
      notes: "Заметки",
    },
    categories: {
      leadership: "Лидерство",
      creative: "Творчество",
      analytical: "Аналитика",
      communication: "Коммуникации",
      care: "Помощь людям",
      business: "Бизнес",
    },
    categoriesHints: {
      leadership: "Управление, стратегия, влияние",
      creative: "Дизайн, медиа, креативные индустрии",
      analytical: "Данные, технологии, исследования",
      communication: "Маркетинг, продажи, переговоры",
      care: "Помогающие профессии, наставничество",
      business: "Предпринимательство, финансы, рост",
    },
  },
  cta: {
    title: "Судьба ждет",
    description: "Присоединяйтесь к сообществу из более чем 100 000 искателей, следующих за звездами. Ваша судьба — это не пункт назначения, а частота.",
    button: "Войти в святилище"
  },
  persona: {
    title: "Создание персоны",
    subtitle: "Введите данные вашего рождения, чтобы составить карту вашего космического чертежа.",
    name: "Полное имя",
    birthDate: "Дата рождения",
    birthTime: "Время рождения",
    birthPlace: "Место рождения",
    gender: "Пол",
    genders: {
      male: "Мужской",
      female: "Женский",
      other: "Другой"
    },
    submit: "Создать персону",
    placeholders: {
      name: "Введите имя",
      place: "Город, Страна",
      time: "00:00"
    }
  },
  traits: {
    characteristicsTitle: "Выберите характеристики (до 3)",
    talentsTitle: "Выберите таланты",
    prioritiesTitle: "Выберите приоритет (один)",
    notesTitle: "Дополнительные заметки",
    notesSubtitle: "Опишите дополнительные пожелания или важные моменты для будущего ребенка",
    notesPlaceholder: "Введите ваши заметки...",
    birthLocationTitle: "Планируемое место рождения",
    birthLocationSubtitle: "Укажите место, где планируется рождение ребенка. Это важно для точного расчета натальной карты.",
    plannedBirthPlace: "Место рождения",
    parentsSubtitle: "Данные родителей используются для анализа совместимости",
    parent1Title: "Родитель 1",
    parent2Title: "Родитель 2",
    parentsData: "Данные родителей",
    birthDate: "Дата рождения",
    birthTime: "Время рождения",
    birthPlace: "Место рождения",
    optional: "необязательно",
    summaryTitle: "Резюме",
    list: {
      leadership: "Лидерство",
      creativity: "Творчество",
      empathy: "Эмпатия",
      intelligence: "Интеллект",
      communication: "Общение",
      discipline: "Дисциплина",
      intuition: "Интуиция",
      energy: "Энергия",
      kindness: "Доброта",
      confidence: "Уверенность",
      patience: "Терпение",
      curiosity: "Любознательность",
    },
    talents: {
      music: "Музыка",
      art: "Искусство",
      sports: "Спорт",
      academic: "Учеба",
      social: "Общение",
      technical: "Техническое",
    },
    priorities: {
      family: "Семья",
      career: "Карьера",
      wealth: "Богатство",
      health: "Здоровье",
      education: "Образование",
      relationships: "Отношения",
    },
  },
  stepper: {
    back: "Назад",
    next: "Далее",
    stepProgress: "Шаг {{current}} из {{total}}",
  },
  footer: {
    tagline: "Звезды склоняют, но не обязывают.",
    links: ["Оракул", "Архив", "Контакты"],
    copy: "© 2025 astrobaby"
  },
  dashboard: {
    badge: "Дашборд",
    welcome: "Добро пожаловать, {{name}}!",
    subtitle: "Ваша персональная космическая лаборатория. Исследуйте звёзды, узнавайте себя и близких.",
    createProfile: "Создайте свой профиль",
    createProfileDescription: "Для персональных прогнозов и \"Моего дня\" нам нужны ваши данные рождения.",
    createProfileButton: "Создать профиль",
    cosmicTools: "Космические инструменты",
    quickOverview: "Действия",
    sunSign: "Солнечный знак",
    profile: "Профиль",
    birthDate: "Дата рождения",
    mySubscription: "Моя подписка",
    subscriptionActive: "Активна",
    subscriptionInactive: "Нет подписки",
    subscribe: "Подписаться",
    features: {
      natalChart: {
        title: "Натальные карты",
        description: "Управление профилями и натальными картами",
        myChartButton: "Моя натальная карта",
      },
      compatibility: {
        title: "Совместимость",
        description: "Анализ космической связи с партнёром",
      },
      astroCareer: {
        title: "Астро‑профориентолог",
        description: "Профориентация по натальной карте и сильным качествам",
      },
      lifeTimeline: {
        title: "Линия жизни",
        description: "Персональный таймлайн вероятных периодов и пиков",
      },
      calendar: {
        title: "Когда лучше?",
        description: "Опиши ситуацию и найди лучшие даты для важных дел",
      },
      transits2026: {
        title: "Транзиты 2026",
        description: "Персональный разбор по транзитам 2026 года",
      },
      haircutCalendar: {
        title: "Лунный календарь",
        description: "Узнайте лучшие дни для стрижки по лунному календарю",
      },
      pregnancyPlanning: {
        title: "Планирование беременности",
        description: "Расчёт благоприятных дат для зачатия с астрологическим анализом",
      },
      people: {
        title: "Люди",
        description: "Управление профилями близких и создание натальных карт",
      },
    },
    footer: "Звёзды склоняют, но не обязывают",
    calculationsHistory: {
      title: "Космические хроники",
      view: "Открыть",
    },
  },
  calculationsHistory: {
    badge: "Архив",
    title: "Космические хроники",
    subtitle: "История всех ваших астрологических расчетов",
    view: "Просмотр",
    partner1: "Партнёр 1",
    partner2: "Партнёр 2",
    untitled: "Без названия",
    types: {
      elections: "Когда лучше?",
      compatibility: "Совместимость",
      conception: "Планирование зачатия",
      lifeTimeline: "Линия жизни",
      astroCareer: "Астро‑профориентолог",
      unknown: "Расчёт",
    },
    elections: {
      windows: "Окон удачи: {{count}}",
      stops: "Периодов избегать: {{count}}",
    },
    compatibility: {
      score: "Совместимость: {{score}}%",
    },
    conception: {
      dates: "Благоприятных дат: {{count}}",
      titleWithDates: "Планирование зачатия • {{count}} дат",
      titleWithDate: "Планирование зачатия • {{date}}",
    },
    table: {
      type: "Тип",
      title: "Название",
      details: "Детали",
      date: "Дата",
      actions: "Действия",
    },
    empty: {
      title: "Пока нет расчетов",
      description: "Создайте свой первый расчет, чтобы увидеть его здесь",
      action: "Перейти к инструментам",
    },
  },
  myDay: {
    title: "Мой день",
    subtitle: "Персональные астрологические прогнозы",
    loading: "Астролог рассчитывает ваш день...",
    affirmationTitle: "Аффирмация дня",
    forecastsTitle: "Прогнозы на сегодня",
    noContent: "Контент на сегодня не готов",
    noContentDescription: "Он будет сгенерирован автоматически",
    regenerateContent: "Получить контент",
    regenerating: "Генерируем...",
    updateContent: "Обновить контент",
    updating: "Обновляем...",
    subscribeRequired: "Подписка необходима для персональных прогнозов",
    selectPersonRequired: "Выберите \"это я\"",
    selectPersonDescription: "Выберите человека для персонализированных прогнозов",
    goToPeople: "Перейти к людям",
    subscribeButton: "Оформить подписку",
    contentUpdated: "Контент успешно обновлен",
    updateError: "Не удалось обновить контент",
    loadError: "Не удалось загрузить контент",
    adviceTitle: "Совет дня",
    showAll: "Показать все категории",
    collapse: "Свернуть",
    outOf: "из",
    categories: {
      love: "Любовь",
      career: "Карьера",
      social: "Общение",
      energy: "Энергия",
      intuition: "Интуиция",
      health: "Здоровье",
      finance: "Финансы",
      creativity: "Творчество",
    },
  },
  onboarding: {
    title: "Создание профиля",
    steps: {
      name: {
        title: "Имя",
        description: "Как к вам обращаться?",
      },
      birthDate: {
        title: "Дата рождения",
        description: "Когда вы пришли в этот мир?",
      },
      birthTime: {
        title: "Время рождения",
        description: "Знаете точное время?",
        descriptionRequired: "Для точных прогнозов нужно знать время рождения",
      },
      birthDateTime: {
        title: "Дата и время рождения",
        description: "Точные данные нужны для расчёта вашей карты",
      },
      birthPlace: {
        title: "Место рождения",
        description: "Где вы родились?",
      },
      success: {
        title: "Готово!",
        description: "Ваш космический профиль создан",
      },
    },
    form: {
      nameLabel: "Ваше имя",
      namePlaceholder: "Введите имя",
      genderLabel: "Пол",
      birthDateLabel: "Дата рождения",
      birthDateHint: "Это поможет рассчитать вашу натальную карту",
      birthTimeLabel: "Время рождения (если знаете)",
      birthTimeLabelRequired: "Время рождения",
      birthTimeHint: "Точное время позволяет определить асцендент и дома. Если не знаете — пропустите.",
      birthTimeHintRequired: "Точное время необходимо для расчёта асцендента и домов вашей карты.",
      birthPlaceLabel: "Место рождения",
      birthPlacePlaceholder: "Город, Страна",
      birthPlaceHint: "Место рождения влияет на положение домов в карте",
    },
    gender: {
      male: "Мужской",
      female: "Женский",
      other: "Другой",
    },
    buttons: {
      back: "Назад",
      next: "Далее",
      skip: "Пропустить",
      createProfile: "Создать профиль",
      saving: "Сохранение...",
      goToDashboard: "Перейти в личный кабинет",
    },
    success: {
      title: "Добро пожаловать, {{name}}!",
      description: "Ваш космический профиль создан. Теперь вы можете получать персональные прогнозы.",
    },
    skipLink: "Пропустить и настроить позже",
    profileCreated: "Профиль создан!",
    errorCreating: "Ошибка при создании профиля",
    alreadyHasProfile: "У вас уже есть профиль",
  },
  location: {
    placeholder: "Введите город или место",
  },
  people: {
    form: {
      name: "Имя",
      nameRequired: "Имя обязательно",
      namePlaceholder: "Введите имя",
      birthDate: "Дата рождения",
      birthDateRequired: "Дата рождения обязательна",
      birthTime: "Время рождения",
      birthPlace: "Место рождения",
      birthPlaceRequired: "Место рождения обязательно",
      birthPlaceSelect: "Выберите место из списка",
      addPerson: "Добавить человека",
      addPersonDescription: "Введите данные для создания новой персоны",
      saving: "Сохранение...",
      add: "Добавить",
    },
    gender: {
      male: "Мужской",
      female: "Женский",
      other: "Другой",
    },
    selector: {
      label: "Выберите человека",
      placeholder: "Выберите из списка...",
      noAvailable: "Нет доступных людей",
      createNew: "Создать нового",
      selectExisting: "Выбрать из существующих",
      clear: "Очистить",
    },
    relationship: {
      self: "Я",
      partner: "Партнер",
      child: "Ребенок",
      parent: "Родитель",
      friend: "Друг",
      other: "Другое",
    },
  },
  zodiac: {
    aries: "Овен",
    taurus: "Телец",
    gemini: "Близнецы",
    cancer: "Рак",
    leo: "Лев",
    virgo: "Дева",
    libra: "Весы",
    scorpio: "Скорпион",
    sagittarius: "Стрелец",
    capricorn: "Козерог",
    aquarius: "Водолей",
    pisces: "Рыбы",
  },
  common: {
    loading: "Загрузка...",
    error: "Ошибка",
    save: "Сохранить",
    cancel: "Отмена",
    open: "Открыть",
  },
  subscription: {
    title: "Подписка",
    premium: "Premium",
    choosePlan: "Выберите подписку",
    monthly: "Месячная",
    yearly: "Годовая",
    perMonth: "₽/мес",
    perYear: "₽/год",
    savings: "Экономия",
    subscribe: "Оформить",
    features: {
      title: "Что включено",
      natalChart: "Полная натальная карта",
      compatibility: "Совместимость партнёров",
      calendar: "Когда лучше?",
      forecasts: "Персональные прогнозы",
      interpretations: "Расширенные интерпретации",
    },
    paywall: {
      title: "Доступно по подписке",
      description: "Оформите подписку, чтобы получить полный доступ к этой функции",
      subscribeButton: "Оформить подписку",
      priceFrom: "От 499 ₽/месяц",
      cancelAnytime: "Отмена в любой момент",
      unlockPremium: "Разблокируйте Premium",
      unlockCompatibility: "Разблокируйте совместимость",
      unlockCalendar: "Разблокируйте Когда лучше?",
      compatibilityAvailable: "Совместимость доступна по подписке",
      compatibilityDescription: "Оформите подписку Premium, чтобы получить доступ к анализу совместимости партнёров",
      calendarAvailable: "Когда лучше? доступно по подписке",
      calendarDescription: "Оформите подписку Premium, чтобы получить доступ к выбору лучших дат для важных дел",
      chartDescription: "Получите доступ к расширенному анализу натальной карты",
      sectionLocked: "Раздел \"{{section}}\" доступен с подпиской Premium",
      starsInfluence: "Узнайте, как звёзды влияют на ваши отношения",
      findBestMoments: "Найдите лучшие моменты для важных решений",
      planetDescriptions: "Оформите подписку, чтобы получить подробные описания всех планет",
      planetDescriptionsTitle: "Описания планет",
      aspectsDescriptions: "Оформите подписку, чтобы увидеть все аспекты и их описания",
      aspectsDescriptionsTitle: "Остальные аспекты",
      transits2026Description: "Оформите подписку Premium, чтобы получить персональный разбор по транзитам 2026 года",
      transits2026Title: "Транзиты 2026 доступны по подписке",
      pregnancyPlanningDescription: "Эта функция доступна только по подписке. Получи полный доступ к расчёту благоприятных дат зачатия, анализу совместимости родителей и расширенным интерпретациям.",
      pregnancyPlanningPrice: "499₽/мес или 4990₽/год",
    },
    success: {
      title: "Оплата прошла успешно!",
      premiumActivated: "Premium активирован",
      description: "Теперь вам доступны все премиум-функции AstroBaby",
      goToApp: "Перейти в приложение",
      redirecting: "Автоматический переход через",
    },
    payment: {
      title: "Оплата подписки",
      securePayment: "Безопасная оплата через CloudPayments",
      cards: "Visa, Mastercard, МИР, СБП",
      instantConfirmation: "Мгновенное подтверждение",
    },
  },
  chart: {
    tabs: {
      personality: "Личность и судьба",
      love: "Любовь и отношения",
      career: "Карьера и деньги",
      "light-dark": "Свет и тьма",
      children: "Детская астрология",
      pro: "PRO"
    },
    viewChart: "Посмотреть карту",
    closeChart: "Вернуться к чтению",
    natalBlueprint: "Натальный чертёж",
    celestialProjection: "Небесная проекция",
    sacredMapFor: "Священная карта для {{name}}",
    aligningAstralVectors: "Выравнивание астральных векторов...",
    starsRevealing: "Звёзды раскрывают вашу информацию о {{section}}. Знание готовится проявиться.",
    planetAspects: "Аспекты планет",
    planetAspectsDesc: "Профессиональный анализ аспектов между планетами в вашей натальной карте.",
    horoscopeHouses: "Дома гороскопа",
    horoscopeHousesDesc: "Детальный разбор положения планет в домах гороскопа.",
    sunInSign: "Солнце в {{sign}}",
    ascendantInSign: "Асцендент в {{sign}}",
    moonInSign: "Луна в {{sign}}",
    reset: "Сбросить",
    born: "Рождён {{date}}, {{time}} • {{place}}",
    calculatingChart: "Рассчитываем карту...",
  },
  compatibility: {
    title: "Космическая совместимость",
    subtitle: "Узнайте, как ваши энергии переплетаются с другой душой.",
    partnersCompatibility: "Совместимость партнёров",
    discoverInfluence: "Узнайте, как звёзды влияют на вашу связь и раскройте потенциал отношений",
    person1: "Первый искатель",
    person2: "Второй искатель",
    type: "Тип связи",
    types: {
      love: "Любовь и отношения",
      business: "Бизнес и карьера",
      friendship: "Дружба",
      family: "Семья и корни"
    },
    calculate: "Совместить энергии",
    result: {
      score: "Уровень соответствия",
      strengths: "Космические сильные стороны",
      weaknesses: "Небесные вызовы",
      periods: "Важные периоды",
      divineAlignment: "Божественное выравнивание в аспекте {{num}}",
      karmicLesson: "Кармический урок в поле {{num}}",
    }
  },
  settings: {
    title: "Настройки",
    description: "Управление профилем и подпиской",
    keywords: "настройки, профиль, подписка, управление",
    badge: "Настройки",
    subtitle: "Управляйте своим профилем и подпиской",
    profile: {
      title: "Профиль",
      description: "Информация о вашем аккаунте",
      email: "Электронная почта",
      displayName: "Имя",
      linkedAccounts: "Связанные аккаунты",
    },
    subscription: {
      title: "Подписка",
      description: "Управление вашей подпиской",
      status: {
        label: "Статус",
        active: "Активна",
        cancelled: "Отменена",
        expired: "Истекла",
      },
      currentPeriod: "Текущий период",
      nextBilling: "Следующее списание",
      amount: "Сумма",
      noSubscription: "У вас нет активной подписки",
      subscribeButton: "Оформить подписку",
      manage: "Управлять",
      cancelButton: "Отменить подписку",
      cancelConfirm: "Вы уверены, что хотите отменить подписку? Она будет активна до конца оплаченного периода.",
      cancelYes: "Да, отменить",
      cancelNo: "Нет",
      cancelled: "Подписка успешно отменена",
      cancelError: "Ошибка при отмене подписки",
      unknownError: "Произошла неизвестная ошибка",
      changeMe: {
        title: "Смена профиля «Я»",
        description: "Выберите новый профиль для расчета транзитов и прогнозов",
        selectPerson: "Выбрать профиль",
        currentPerson: "Текущий профиль «Я»",
        changeButton: "Сменить",
        changing: "Меняю...",
        changed: "Профиль «Я» успешно изменен",
        changeError: "Ошибка при смене профиля",
        limitReached: "Смена профиля «Я» доступна не чаще раза в месяц",
        daysRemaining: "Следующая смена доступна через",
        recalculationNote: "После смены будут пересчитаны транзиты 2026 и «Мой день»",
      },
    },
    actions: {
      signOut: "Выйти из аккаунта",
    },
  },
};
